export default {
      id: "issue-duplicate-policy-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#issue-duplicate-policy",
      toString: function () {
        return this.url;
      }
    }